/**
 * User: Shad
 * Date: 8/19/13
 */
"use strict";
var SoaModel = require('bunsen/models/SoaModel');

var paymentMethodFactory = SoaModel.extend({
    constructor: function (data, options) {
        // declared down here for circular dependency reasons
        var WireTransfer = require('bunsen/models/ecomm/payment-methods/WireTransfer');
        var Check = require('bunsen/models/ecomm/payment-methods/Check');
        var CreditToUserAccount = require('bunsen/models/ecomm/payment-methods/CreditToUserAccount');
        var Discount = require('bunsen/models/ecomm/payment-methods/Discount');
        var DirectPayment = require('bunsen/models/ecomm/payment-methods/DirectPayment');
        var Cash = require('bunsen/models/ecomm/payment-methods/Cash');
        var ACH = require('bunsen/models/ecomm/payment-methods/ACH');
        var NotAvailable = require('bunsen/models/ecomm/payment-methods/NotAvailable');
        var CreditCard = require('bunsen/models/ecomm/payment-methods/CreditCard');
        var PayPalAccount = require('bunsen/models/ecomm/payment-methods/PayPalAccount');
        var ApplePay = require('bunsen/models/ecomm/payment-methods/ApplePay');

        switch (data.paymentMethodType) {
            case 'WIRE_TRANSFER':
                return new WireTransfer(data, options);
            case 'CHECK':
                return new Check(data, options);
            case 'CREDIT_TO_USER_ACCOUNT':
                return new CreditToUserAccount(data, options);
            case 'DISCOUNT':
                return new Discount(data, options);
            case 'DIRECT_PAYMENT':
                return new DirectPayment(data, options);
            case 'CASH':
                return new Cash(data, options);
            case 'ACH':
                return new ACH(data, options);
            case 'NOT_AVAILABLE':
                return new NotAvailable(data, options);
            case 'PAYPAL_ACCOUNT':
                return new PayPalAccount(data, options);
            case 'CREDIT_CARD':
                return new CreditCard(data, options);
            case 'APPLE_PAY':
                return new ApplePay(data, options);
            default:
                return new CreditCard(data, options);
        }
    }
});

module.exports = paymentMethodFactory;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/PaymentMethod.js
// module id = 57
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54